<div class="auth-page" role="main" aria-label="Reset password page">
    <div class="auth-card-wrapper">
        <div class="auth-card">
            <div class="auth-form-wrapper form-section">
                <h3 [appTranslate]="'RESET_PASSWORD'"></h3>

                <div class="form-group">
                    <label for="reset-password-email" [appTranslate]="'EMAIL'"></label>
                    <input id="reset-password-email" type="email" class="form-control" name="email" [(ngModel)]="model.Email"
                        aria-describedby="reset-password-email-errors">
                    <div id="reset-password-email-errors" class="errors error-messages">
                        <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="form-group">
                    <label for="reset-password-code" [appTranslate]="'CODE'"></label>
                    <input id="reset-password-code" type="text" class="form-control" name="code" [(ngModel)]="model.Code"
                        aria-describedby="reset-password-code-errors">
                    <div id="reset-password-code-errors" class="errors error-messages">
                        <app-error [errors]="errors" [ErrorKey]="'code'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="form-group">
                    <label for="reset-password-new" [appTranslate]="'NEW_PASSWORD'"></label>
                    <input id="reset-password-new" type="password" class="form-control" name="newPassword" [(ngModel)]="model.NewPassword"
                        aria-describedby="reset-password-new-errors">
                    <div id="reset-password-new-errors" class="errors error-messages">
                        <app-error [errors]="errors" [ErrorKey]="'NewPassword'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="form-group">
                    <label for="reset-password-confirm" [appTranslate]="'CONFIRM_PASSWORD'"></label>
                    <input id="reset-password-confirm" type="password" class="form-control" name="confirmPassword"
                        [(ngModel)]="model.ConfirmPassword" aria-describedby="reset-password-confirm-errors">
                    <div id="reset-password-confirm-errors" class="errors error-messages">
                        <app-error [errors]="errors" [ErrorKey]="'ConfirmPassword'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="loginBtn">
                    <button type="button" class="btn-primary" (click)="resetPassword()"><span
                            [appTranslate]="'CONFIRM'"></span>
                    </button>
                </div>

                <!-- <div class="errors error-messages">
                    <app-error [errors]="errors" [ErrorKey]="''" class="error-feedback"></app-error>
                </div> -->

                <div *ngIf="successfulReg" class="success-message">
                    <span [appTranslate]="'CHANGE_PASS_SUCCESS'"></span>
                    <button type="button" (click)="redirect()" [appTranslate]="'TO_LOGIN'" aria-label="Go to login"></button>
                </div>
            </div>
        </div>
    </div>
</div>